import React from "react";

const socialIcons = [
  "./../assets/corporateAssert/Adiuvo_logo.png",
  "./../assets/corporateAssert/TeraLumen_logo.png",
  "./../assets/corporateAssert/E-Hands_logo.png",
  "./../assets/corporateAssert/RE4Billion_logo.png",
  "./../assets/corporateAssert/Adiuvo_logo.png",
  "./../assets/corporateAssert/TeraLumen_logo.png",
  "./../assets/corporateAssert/E-Hands_logo.png",
  "./../assets/corporateAssert/RE4Billion_logo.png",
];

export default function Testimonial() {
  return (
    <div className="Testimonial-contain" >
      <div>
        <div className="Testimonial-heading mt-20 p-5">
          <p>Success Stories</p>
        </div>

        <div className="mt-5 p-5 md:p-10">

          <div className="profile-card-page">

            <div className="profile-card">
              <div className="p-5 flex flex-col flex-1">

                <h2 className="profile-card__name">Vikasini</h2>

                <img
                  src="./../assets/corporateAssert/starGroup.png"
                  className="StartGroup"
                  alt="Rating Stars"
                />

                <p className="profile-card__description mt-2">
                  I've been greatly benefitted after following the simple remedies and lifestyle practices advised by Doctor from Aiwell for intermittent dry cough and cramps.
                </p>

              </div>
            </div>

            <div className="profile-card">
              <div className="p-5 flex flex-col flex-1">
                <h2 className="profile-card__name">Venkatesh Vedagiri</h2>
                <img
                  src="./../assets/corporateAssert/starGroup.png"
                  className="StartGroup"
                  alt="Rating Stars"
                />
                <p className="profile-card__description mt-2">
                  I've struggled with sleep for four years, spending much on treatments that never worked. Since joining the wellness program, I now sleep over 8 hours thanks to the AyurAI health coach who really listened and provided a solution that worked. Thank you so much!
                </p>
              </div>
            </div>

          </div>

        </div>

        <div className="Testimonial-heading mb-10  mt-20">
          <p>Current Clients</p>
        </div>

        <div className="profile-card__social">
          <div className="marquee">
            <div className="marquee-content" aria-hidden="true">
              {socialIcons.concat(socialIcons).map((icon, index) => (
                <img
                  key={index}
                  src={icon}
                  alt="Social Icon"
                  className="profile-card__social-icon"
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
